import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default class ArticleMenu {
	constructor(el, target) {
		this.el = el;
		this.target = target;
		this.menuItems = this.target.querySelectorAll('[data-module-target]');
		this.moduleGroups = this.target.querySelectorAll('[data-module-group]');
		this.toggleButton = this.el.querySelector('[data-toggle-article-menu]');

		this.desktopMenuContainer = this.target.querySelector('[data-menu-container]');
		this.mobileMenuContainer = this.target.querySelector('[data-mobile-menu-container]');

		const scrollArea = this.target.querySelector(this.el.dataset.articleMenu);

		if (!scrollArea) {
			return;
		}

		this.createMenuScrollTrigger(scrollArea);

		this.el.addEventListener('click', (e) => {
			this.handleMenuItemClick(e);
			this.handleToggleClick(e);
		});

		document.addEventListener('scroll', this.checkScroll.bind(this));
		this.checkScroll();

		window.addEventListener('resize', this.handleResize.bind(this));
		this.handleResize();
	}

	handleToggleClick(e) {
		if (window.matchMedia('(min-width:768px)').matches) {
			return;
		}

		if (!e.target) {
			return;
		}

		const button = e.target?.closest('[data-toggle-article-menu]');

		if (!button) {
			return;
		}

		e.preventDefault();

		this.el.classList.toggle('is-open');
		button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') == 'true' ? 'false' : 'true');
	}

	handleMenuItemClick(e) {
		if (!e.target) {
			return;
		}

		const menuLink = e.target?.closest('.c-article-menu__link');

		if (!menuLink) {
			return;
		}

		e.preventDefault();

		gsap.to(window, { duration: 0.6, scrollTo: { y: menuLink.hash, offsetY: 115 } });
	}

	handleResize() {
		// Desktop
		if (window.matchMedia('(min-width:768px)').matches) {
			if (this.el.closest('[data-menu-container]')) {
				return;
			}

			this.desktopMenuContainer.appendChild(this.el);

			return;
		}

		// Mobile
		if (this.el.closest('[data-mobile-menu-container]')) {
			return;
		}

		this.mobileMenuContainer.appendChild(this.el);
	}

	checkScroll() {
		if (!window.matchMedia('(min-width:768px)').matches) {
			return;
		}

		const check = window.scrollY + 200;

		this.moduleGroups.forEach((group, index) => {
			const rect = group.getBoundingClientRect();
			let active = false;

			if (
				check >= rect.top + document.documentElement.scrollTop &&
				check <= rect.bottom + document.documentElement.scrollTop
			) {
				active = true;
				this.menuItems[index].classList.add('is-active');
			} else {
				active = false;
				this.menuItems[index].classList.remove('is-active');
			}
		});
	}

	createMenuScrollTrigger(trigger) {
		let mm = gsap.matchMedia();

		mm.add('(min-width: 786px)', () => {
			ScrollTrigger.create({
				trigger: trigger,
				start: 'top top+=100px',
				end: () => `bottom top+=${this.el.offsetHeight + 100}px`,
				pin: this.el,
				pinSpacing: false,
			});
		});
	}

	static init() {
		document.addEventListener('bless', (e) => {
			if (!e.target) {
				return;
			}

			e.target.querySelectorAll('[data-article-menu]').forEach((el) => new ArticleMenu(el, e.target));
		});
	}
}
